// // import styled from "styled-components"
// // import { Link, Outlet, useNavigate } from "react-router-dom"
// // import Modal from "../../SharedFns/Modal"
// // import LoanPaymentTransactions from "LoanPaymentTransactions"
// // import { useState } from "react"

// // const OverAllTransactions=()=>{
// //     const[isModalOpen, setIsModalOpen]=useState(false)
// //     const navigate=useNavigate()
// //     const handleClick= (route)=>{
// //            navigate(route) 
// //     }
// //     return(
// //         <Container>
// //             <Content>
// //             <Header>
// //                 <h2> Your Transactions History</h2>
// //             </Header>
// //             <LinksContainer>
// //             <Linkto  to ='loan-payments' > Loan Payments</Linkto>
// //             <Linkto to='contrib-payments'> Contribution Payments</Linkto>
// //             <Linkto to='loan-applications'>Loan Applications</Linkto>
           
// //             </LinksContainer>
// //             <RenderTransactions>
// //             <Outlet/>
// //             </RenderTransactions>
          
// //             {/* <Modal isOpen={isModalOpen} onClose={()=>setIsModalOpen(false)}>
// //                 {<LoanPaymentTransactions />}
// //             </Modal> */}
            
// //             </Content>
            
           
          
// //             </Container>
// //     )


// // }
// // const Container = styled.div`
// //   width: 100%;
// //   height: 100%;
// //   display: flex;
// //   flex-direction: column;
// //   justify-content: flex-start;
// //   overflow-y: scroll;

// //   @media (max-width: 768px) {
// //     width: 100%;
// //     /* Remove the overflow-x: scroll property */
// //     /* overflow-x: scroll; */
// //   }
// // `;

// // const Content=styled.div`
// // width:100%;
// // display:flex;
// // flex-direction:column;
// // height:100%;
// // overflow-x:scroll;
// // `
// // const Table=styled.table`
// // border-collapse:collapse;
// // width:100%;

// // margin-bottom:100px;
// // `
// // const TableHeader=styled.th`
// // border: solid 1px #000;
// // background-color:#f2f2f2;
// // padding:10px;

// // ` 
// // const TableCell = styled.td`
// //   border: 1px solid #000;
// //   padding: 10px;
// //   text-align: left;
// //   @media (max-width:768px) {
// //   width:12px;
// //   height: 10%;
// //   font-size:10px;
// //   &.hide-on-small-screen {
// //     display: none; // hide this column on small screens
// //   }
  
// // }
// // `
// // const LinksContainer = styled.div`
// //   display: flex;
// //   justify-content: flex-start;
// //   align-items: center;
// //   padding: 10px;
// //   width: 100%;
// //   border-bottom: solid 1px gray;
// //   margin-bottom: 10px;
// //   margin-left:20px;

// //   @media (max-width: 768px) {
// //     display: flex;
// //     flex-direction:row;
// //     align-items:flex-start;
// //     justify-content:space-around;
// //     width:145%;
// //     padding-bottom:5px;
// //     padding-left:10px;
// //     overflow-x: auto;
// //     height:70px;
// //     margin-bottom:20px;
// //   }
// // `;

// // const Header = styled.div`
// //   width: 100%;
// //   display: flex;
// //   justify-content: flex-start;
// //   align-items: flex-start;
// //   flex-direction: row;
// //   height: 70px;
// //   margin-left: 20px;
// //   margin-bottom: 10px;
// //   border-bottom: solid 1px gray;
// //   margin-top: 20px;

// //   @media (max-width: 768px) {
// //     height: 50px;
// //     width:145%;
// //     .h2 {
// //       font-size: 14px;
// //     }
// //   }
// // `;

// // const RenderTransactions = styled.div`
// //   width: 100%;
// //   padding: 10px;
// //   margin-left: 20px;

// //   @media (max-width: 768px) {
// //     margin-left: 0px;
 
// //     width:100%;
// //     /* width: calc(100% - 20px); Adjust the margin accordingly */
// //   }
// // `;
// // const Linkto = styled(Link)`
// //   cursor: pointer;
// //   text-decoration: none;
// //   display: flex;
// //   justify-content: center;
// //   align-items: center;
// //   cursor: pointer;

// //   margin: 5px;
// //   width: 24%; /* Set width to create a 2 by 2 layout on small screens */
// //   box-sizing: border-box; /* Ensure padding and border don't affect width */
// //   padding:10px;
// //   border-radius: 10px;
// //   background-color: #e2725b;
// //   color: #f9f9f9;
// //   border: none;
// //   border-color: #e2725b;

// //   @media (max-width: 768px) {
// //     width: 100%; /* Adjust width for small screens */
// //     max-width: 100px; /* Remove max-width for small screens */
// //     height: 30px;
// //     font-size: 10px;
// //     padding-left:5px;
// //     margin-left: 2px;
   
// //   }
// // `;



// // // const RenderTransactions=styled.div`
// // // width:100%;
// // // padding:10px;
// // // margin-left:20px;
// // // @media (max-width: 768px) {
// // //     width:100vw;
    
// // // }

// // // `


// import styled from "styled-components";
// import { Link, Outlet, useLocation } from "react-router-dom";

// const OverAllTransactions = () => {
//   const location = useLocation();

//   return (
//     <Wrapper>
//       <Sidebar>
//         <h3>📊 Transactions</h3>
//         <NavLink to="loan-payments" $active={location.pathname.includes("loan-payments")}>
//           💳 Loan Payments
//         </NavLink>
//         <NavLink to="contrib-payments" $active={location.pathname.includes("contrib-payments")}>
//           💰 Contributions
//         </NavLink>
//         <NavLink to="loan-applications" $active={location.pathname.includes("loan-applications")}>
//           📝 Loan Applications
//         </NavLink>
//       </Sidebar>

//       <Main>
//         <Header>
//           <h2>📄 Transaction History</h2>
//           <p>Select a section to view detailed records.</p>
//         </Header>
//         <Outlet />
//       </Main>
//     </Wrapper>
//   );
// };

// export default OverAllTransactions;
// const Wrapper = styled.div`
//   display: flex;
//   width: 100%;
//   height: 100%;
//   flex-direction: row;

//   @media (max-width: 768px) {
//     flex-direction: column;
//   }
// `;

// const Sidebar = styled.div`
//   width: 220px;
//   background-color: #f7f7f7;
//   border-right: 1px solid #ccc;
//   padding: 15px;
//   min-height: 100vh;

//   h3 {
//     font-size: 16px;
//     margin-bottom: 16px;
//     color: #333;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     border-right: none;
//     border-bottom: 1px solid #ccc;
//     display: flex;
//     flex-direction: row;
//     justify-content: space-around;
//     padding: 10px 5px;
//     h3 {
//       display: none;
//     }
//   }
// `;

// const NavLink = styled(Link)`
//   display: block;
//   padding: 8px 10px;
//   margin-bottom: 8px;
//   border-radius: 6px;
//   text-decoration: none;
//   font-size: 14px;
//   font-weight: 500;
//   background-color: ${({ $active }) => ($active ? "#c35d47" : "#e2725b")};
//   color: #fff;
//   transition: background 0.2s ease;

//   &:hover {
//     background-color: #c35d47;
//   }

//   @media (max-width: 768px) {
//     font-size: 11px;
//     padding: 6px;
//     margin: 0 2px;
//     flex: 1;
//     text-align: center;
//   }
// `;


// const Main = styled.div`
//   flex: 1;
//   padding: 20px;
//   min-height: 100vh;
//   overflow-y: auto;

//   @media (max-width: 768px) {
//     padding: 10px;
//   }
// `;

// const Header = styled.div`
//   margin-bottom: 20px;

//   h2 {
//     margin-bottom: 5px;
//     font-size: 22px;
//     color: #333;
//   }

//   p {
//     color: #666;
//     font-size: 14px;
//   }

//   @media (max-width: 768px) {
//     h2 {
//       font-size: 18px;
//     }

//     p {
//       font-size: 12px;
//     }
//   }
// `;


import styled from "styled-components";
import { Link, Outlet, useLocation } from "react-router-dom";

const OverAllTransactions = () => {
  const location = useLocation();

  return (
    <Wrapper>
      <Sidebar>
        <SidebarHeader>📊 Finance Center</SidebarHeader>
        <NavGroup>
          <StyledNavLink to="loan-payments" $active={location.pathname.includes("loan-payments")}>
            💳 Loan Payments
          </StyledNavLink>
          <StyledNavLink to="contrib-payments" $active={location.pathname.includes("contrib-payments")}>
            💰 Contributions
          </StyledNavLink>
          <StyledNavLink to="loan-applications" $active={location.pathname.includes("loan-applications")}>
            📝 Loan Applications
          </StyledNavLink>
        </NavGroup>
      </Sidebar>

      <Main>
        <TopHeader>
          <h2>🧾 Transaction History</h2>
          <p>Review all your financial activities and application history in one place.</p>
        </TopHeader>
        <ContentArea>
          <Outlet />
        </ContentArea>
      </Main>
    </Wrapper>
  );
};

export default OverAllTransactions;
const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background: #fafafa;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.div`
  width: 240px;
  background-color: #ffffff;
  border-right: 1px solid #ddd;
  padding: 20px;

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 10px;
  }
`;

const SidebarHeader = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavGroup = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
  }
`;

const StyledNavLink = styled(Link)`
  text-decoration: none;
  padding: 10px 14px;
  margin-bottom: 10px;
  background-color: ${({ $active }) => ($active ? "#c35d47" : "#e2725b")};
  color: #fff;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  transition: background 0.2s ease;

  &:hover {
    background-color: #b34d39;
  }

  @media (max-width: 768px) {
    flex: 1;
    text-align: center;
    font-size: 12px;
    margin: 0 4px;
    padding: 8px;
  }
`;

const Main = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const TopHeader = styled.div`
  margin-bottom: 25px;

  h2 {
    font-size: 24px;
    margin-bottom: 6px;
    color: #222;
  }

  p {
    font-size: 14px;
    color: #555;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 18px;
    }

    p {
      font-size: 12px;
    }
  }
`;

const ContentArea = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    padding: 15px;
  }
`;
